import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("admin_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("admin_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

const existing = localStorage.getItem("admin_token");
if (existing) api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;

// Global 401 handler: clear expired admin tokens silently + redirect to login
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && (url.includes("/admin/") || url.includes("/auth/me"))) {
      localStorage.removeItem("admin_token");
      delete api.defaults.headers.common["Authorization"];
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

// --- Anonymous analytics (fire-and-forget, never blocks) ---
function getSessionId() {
  let sid = localStorage.getItem("session_id");
  if (!sid) {
    sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("session_id", sid);
  }
  return sid;
}

export function trackEvent(name, data = {}) {
  try {
    if (window.location.pathname.startsWith("/admin")) return; // skip admin traffic
    // 1) Internal analytics (Mongo /api/events) — anonymous, fire-and-forget
    api.post("/events", { name, session_id: getSessionId(), ...data }).catch(() => {});
    // 2) External analytics (GA4, Meta Pixel, TikTok) — fires only if tags loaded + consent granted
    try {
      if (window.gtag) window.gtag("event", name, data);
      if (window.fbq) {
        const fbMap = {
          purchase: "Purchase",
          add_to_cart: "AddToCart",
          checkout_start: "InitiateCheckout",
          begin_checkout: "InitiateCheckout",
          view_product: "ViewContent",
          view_item: "ViewContent",
          sign_up: "CompleteRegistration",
          newsletter_signup: "Lead",
          search: "Search",
        };
        window.fbq("track", fbMap[name] || "CustomEvent", data);
      }
      if (window.ttq) {
        const ttMap = {
          purchase: "CompletePayment",
          add_to_cart: "AddToCart",
          checkout_start: "InitiateCheckout",
          begin_checkout: "InitiateCheckout",
          view_product: "ViewContent",
          view_item: "ViewContent",
          sign_up: "CompleteRegistration",
          search: "Search",
        };
        window.ttq.track(ttMap[name] || "ClickButton", data);
      }
    } catch { /* silent — external analytics never break UX */ }
  } catch { /* ignore */ }
}
